import { CLASS_ACTIVITY_ITEM } from '../../../../../boardDetails/activity/TabActivity/components/constants';
import * as React from 'react';
import { IDefaultContent } from './types';
import { blockMarkdown } from '../../../../../../../../helper/markdownHelper';
import ReactHtmlParser from 'react-html-parser';
import {
    CLASS_CARD_ACTIVITY_ITEM_ADD_VALUE
} from '../../../../../boardDetails/activity/TabActivity/components/ActivityItemBody/constants';

export function DefaultContent({
    label
}: IDefaultContent) {
    return <div className={CLASS_CARD_ACTIVITY_ITEM_ADD_VALUE + ' ' + CLASS_ACTIVITY_ITEM + '__checklist-item'}>
        {ReactHtmlParser(blockMarkdown(label))}
    </div>;
}
